import { useContext } from 'react';
import { styled } from 'styled-components';

import * as api from '../../../api';

import Dropdown from 'react-bootstrap/Dropdown';

import { ConversationContext } from '../../../context/conversationContext';
import { ConfigurationContext } from '../../../context/configurationContext';

import { ReactComponent as MoreSvg } from '../../../assets/more.svg';
import { ReactComponent as LogoutIcon } from '../../../assets/log-out.svg';

interface Props {
  onClose: () => void;
}

const AdditionalMenu: React.FC<Props> = ({ onClose }) => {
  const conversationContext = useContext(ConversationContext);
  const configurationContext = useContext(ConfigurationContext);

  return (
    <Dropdown>
      <AdditionalActions>
        <MoreIcon />
      </AdditionalActions>
      <DropdownMenu>
        <DropdownItem
          onClick={async () => {
            if (!configurationContext?.id) return;
            if (!configurationContext.setAuthenticated) return;
            if (!conversationContext?.resetConversation) return;
            try {
              await api.client.Previsit.logoutAssistant(
                configurationContext.id,
              );
            } catch (error) {
              console.error('Could not log out patient', error);
            }
            configurationContext.setAuthenticated(false);
            conversationContext.resetConversation();
            onClose();
          }}
        >
          <Logout />
          Logout
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

const AdditionalActions = styled(Dropdown.Toggle)`
  background-color: var(--color-white) !important;
  border: 1px solid var(--border-color) !important;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover,
  &:focus,
  &:active {
    background-color: var(--color-white);
    border: 1px solid var(--border-color);
  }

  &::after {
    display: none;
  }
`;

const MoreIcon = styled(MoreSvg)`
  color: var(--color-hint);
`;

const DropdownMenu = styled(Dropdown.Menu)`
  padding: 0;
`;

const DropdownItem = styled(Dropdown.Item)`
  height: 50px;
  display: flex;
  align-items: center;
`;

const Logout = styled(LogoutIcon)`
  margin-right: 10px;
  color: var(--color-hint);
`;

export default AdditionalMenu;
